/* =========================================================
   breaks-page.js
   Save to: assets/breaks-page.js
   Link in theme.liquid with:
     {{ 'breaks-page.js' | asset_url | script_tag }}
   ========================================================= */

(function () {
  'use strict';

  /* ── Toast ────────────────────────────────────────────── */
  let toastEl = null;
  let toastTimer = null;

  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'breaks-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('breaks-toast--visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('breaks-toast--visible');
    }, 2800);
  }

  /* ── Add to Cart ──────────────────────────────────────── */
  window.breaksAddToCart = function (btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function () {
        showToast('✓ Added to cart!');
        btn.textContent = '✓ Added';
        /* Update cart count bubble if your theme uses [data-cart-count] */
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count');
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        showToast('Could not add to cart. Please try again.');
        btn.textContent = originalText;
        btn.disabled = false;
      });
  };
})();
